<style scoped lang="less">
.studyslistrap {
	margin-top: 10px;

	.studyslistitle {
		height: 40px;
		width: 100%;
		background-color: #c2ccd0;
		display: flex;
		align-items: center;
		color: #000;
		font-size: 16px;
		padding-left: 10px;
		p {
			margin-right: 10px;
		}
	}

	.mapcontians {
		background-color: #fff;
		margin-bottom: 20px;
		box-sizing: border-box;
		padding: 20px;
		display: flex;

		.mapupdataleft {
			width: 20%;
			margin-right: 20px;
			cursor: pointer;
			font-size: 16px;

			/deep/ .el-image {
				width: 100%;
				height: 80%;
				display: flex;
				justify-content: center;
				align-items: center;
				border: 1px solid #ccc;
				border-radius: 5px;
				margin-top: 5px;

				.image-slot {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					i {
						font-size: 24px;
						color: #ccc;
						margin-bottom: 5px;
						font-weight: 900;
					}
				}
			}
		}
		.mapupdataright {
			width: 70%;
			font-size: 16px;
			.mapforms {
				margin: 10px 0;
				p {
					margin: 10px 0;
				}
			}
		}
	}
}
.tabslistbtn {
	margin: 10px;
}
.studyslisstep {
	background-color: #fff;
	padding: 10px;
}

.courseitem {
	margin-top: 20px;

	/deep/ .el-collapse-item__header {
		border: none !important;
	}

	/deep/ .el-collapse-item__wrap {
		border: none !important;
	}

	.collapsetitle {
		// background-color: #37a000;
		// color: #fff;
		width: 100%;
		height: 40px;
		align-items: center;
		justify-content: space-between;
		display: flex;

		.collabtn {
			margin-right: 40px;
			p {
				margin: 0 10px;
				text-decoration: underline;
				color: #409eff;
				box-sizing: border-box;
			}
		}

		.collapsetitlleft {
			display: flex;
			align-items: center;
			margin-left: 10px;

			img {
				width: 20px;
				height: 20px;
				margin-right: 10px;
			}

			.d-flex {
				margin-right: 10px;

				p {
					margin: 0 10px;
				}
			}
		}
	}

	.courseitemchild {
		margin-left: 40px;
		position: relative;
		.courseitemcenter {
			position: absolute;
			transform: translateX(-50%);
			left: 50%;

			p {
				margin: 0 10px;
			}
		}

		.courseitemright {
			margin-right: 30px;
			p {
				margin: 0 10px;
				text-decoration: underline;
				color: #409eff;
			}
		}

		/deep/ .el-collapse,
		.el-collapse-item__wrap,
		.el-collapse-item__header {
			border: none;
		}

		/deep/ .el-collapse-item__header {
			background-color: #f0f0f0;
		}

		.courseitemctitle {
			align-items: center;
			width: 100%;
			background-color: #f0f0f0;
			// color: #fff;
			justify-content: space-between;
			height: 40px;

			.courseitems {
				height: 40px;
				align-items: center;
				.bg-primary {
					// width: 60px;
					padding: 0 20px;
					height: 45px;
					display: flex;
					color: #fff;
					align-items: center;
					justify-content: center;
					margin-right: 20px;
					background-color: #409eff !important;
				}
			}
		}
	}
}

/deep/ .el-dialog__body {
	padding: 0px 20px 30px !important;
}
.chiocescircle {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	background-color: #409eff;
}
</style>
<template>
	<div>
		<titles titlename="修改学习地图" titlecontent="这里修改添加地图" :mbx="paths"></titles>
		<div class="studyslistrap">
			<div class="studyslistitle">
				<p style="width: 5px;height: 20px; background-color: #801dae;"></p>
				地图基本信息
			</div>
			<div class="mapcontians">
				<div class="mapupdataleft" @click="addmapfles">
					<p>地图封面：</p>
					<el-image :src="base64s">
						<div slot="error" class="image-slot">
							<i class="el-icon-plus"></i>
							<p style="color: #ccc;">点击，选择上传图片</p>
						</div>
					</el-image>
					<input type="file" accept="image/jpeg, image/png" v-show="false" ref="files" @change="fileschange" />
				</div>
				<div class="mapupdataright">
					<div class="mapforms">
						<p>学习地图名称：</p>
						<el-input v-model="mapobjs.LM_mapName" maxlength="26" placeholder="请输入学习地图名称"></el-input>
					</div>
					<div class="mapforms">
						<p>内容描述：</p>
						<el-input
							v-model="mapobjs.LM_mapContent"
							type="textarea"
							maxlength="200"
							:autosize="{ minRows: 4, maxRows: 10 }"
							show-word-limit
							placeholder="请输入内容描述"
						></el-input>
					</div>
					<div class="mapforms">
						<p>设置有效学习期限：</p>
						<el-date-picker
							v-model="mapobjs.LM_indateDate"
							:picker-options="pickerOptions"
							format="yyyy-MM-dd hh:mm:ss"
							value-format="yyyy-MM-dd hh:mm:ss"
							type="datetime"
							placeholder="设置有效学习期限"
						></el-date-picker>
					</div>
				</div>
			</div>
		</div>

		<el-dialog title="添加学习内容" :visible.sync="planTableVisible" :before-close="handleClose">
			<el-form :model="planTableobj" label-width="100px">
				<el-form-item label="学习资源类型">
					<el-radio-group v-model="planTableobj.PC_resourceType" @input="changeradios">
						<el-radio :label="1">模拟考试</el-radio>
						<el-radio :label="2">预约实训</el-radio>
						<el-radio :label="3">课程学习</el-radio>
						<!-- <el-radio :label="4">试题练习</el-radio> -->
					</el-radio-group>
				</el-form-item>
				<el-form-item :label="changetitle">
					<div v-if="planTableobj.ZY_GUID == ''">
						<div class="chiocescircle" style="cursor: pointer;" @click="changezyid"><span class="el-icon-edit" style="color: #fff;"></span></div>
					</div>
					<div v-else>
						<p>{{ planTableobj.names }}</p>
					</div>
				</el-form-item>
				<el-form-item label="内容名称"><el-input v-model="planTableobj.PC_planContent" placeholder="请输入内容名称" maxlength="30"></el-input></el-form-item>

				<el-form-item label="内容描述">
					<el-input
						v-model="planTableobj.PC_planDescribe"
						type="textarea"
						maxlength="100"
						:autosize="{ minRows: 4, maxRows: 10 }"
						show-word-limit
						placeholder="请输入内容描述"
					></el-input>
				</el-form-item>

				<el-form-item><el-button type="primary" @click="addplancontengt()">添加内容</el-button></el-form-item>
			</el-form>
		</el-dialog>

		<el-drawer :visible.sync="draweritem" :with-header="false" append-to-body destroy-on-close>
			<div v-if="planTableobj.PC_resourceType == 1">
				<!-- 模拟考试 -->
				<chiocetrainstra @coust-change="changeexamin"></chiocetrainstra>
			</div>
			<div v-if="planTableobj.PC_resourceType == 2">
				<!-- 预约实训 -->
				<gettrainsorsb @coust-change="changetrains"></gettrainsorsb>
			</div>
			<div v-if="planTableobj.PC_resourceType == 3">
				<!-- 课程学习 -->
				<changecourse @coust-change="changecoursea"></changecourse>
			</div>
		</el-drawer>

		<el-dialog :title="contentstitle" :visible.sync="contentdialogTableVisible" :before-close="handleClose">
			<el-form :model="contentobj" label-position="left">
				<el-form-item label="名称"><el-input v-model="contentobj.SP_planName" placeholder="请输入名称" maxlength="30" autocomplete="off"></el-input></el-form-item>
				<el-form-item label="步骤内容">
					<el-input
						v-model="contentobj.SP_planContent"
						type="textarea"
						maxlength="100"
						:autosize="{ minRows: 4, maxRows: 10 }"
						show-word-limit
						placeholder="请输入内容描述"
					></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="editspael()">{{ buttonname }}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<div class="studyslistrap">
			<div class="studyslistitle">
				<p style="width: 5px;height: 20px; background-color: #801dae;"></p>
				添加学习进度
			</div>
			<div class="studyslisstep">
				<div class="tabslistbtn" @click="newcourser()"><el-button type="success" icon="el-icon-circle-plus">新增学习地图计划</el-button></div>
				<div class="courseitem">
					<el-collapse accordion>
						<el-collapse-item v-for="(item, index) in mapobjs.gtslist" :key="index">
							<template slot="title">
								<div class="collapsetitle">
									<div class="collapsetitlleft">
										<img src="@/images/courses.svg" alt="" srcset="" />
										<div class="d-flex">
											<p>步骤 {{ index + 1 }}</p>
											<p>{{ item.SP_planName }}</p>
										</div>
									</div>
									<div class="d-flex collabtn">
										<p
											@click="
												$event.stopPropagation();
												addstudycontent(index);
											"
										>
											<span class="el-icon-circle-plus"></span>
											添加学习内容
										</p>
										<p
											@click="
												$event.stopPropagation();
												editsd(item, index);
											"
										>
											<span class="el-icon-edit"></span>
											编辑
										</p>
										<p
											@click="
												$event.stopPropagation();
												delectsd(item);
											"
										>
											<span class="el-icon-delete-solid"></span>
											删除
										</p>
									</div>
								</div>
							</template>
							<div class="courseitemchild" v-for="(child, childidx) in item.gtPlancontents" :key="childidx" style="margin: 10px 0 0 60px;">
								<div class="d-flex courseitemctitle">
									<div class="d-flex courseitems">
										<div class="bg-primary">{{ index + 1 }}.{{ childidx + 1 }}</div>
										<p class="mr-1">{{ child.PC_planContent }}</p>
									</div>
									<div class="d-flex courseitemcenter"><p style="color: #009be8;">已设置学习资源</p></div>
									<div style="cursor: pointer;" class="d-flex courseitemright" @click="delictcourse(index, child)">
										<p>
											<span class="el-icon-delete-solid"></span>
											删除
										</p>
									</div>
								</div>
							</div>
						</el-collapse-item>
					</el-collapse>
				</div>
				<div class="tabslistbtn" @click="savesmap"><el-button type="success" icon="el-icon-suitcase-1">保存</el-button></div>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { getBase64 } from '@/utils/utils';

import { UpdateLearnmap, changeUploadFileAsync, LearnmapDetails } from '@/request/api/homesview/yunhomes/yunhom.js';

import chiocetrainstra from '@/components/chiocesqutions/chiocetrainstra.vue';

import changecourse from '@/components/chiocesqutions/changecourse.vue';

import gettrainsorsb from '@/components/chiocesqutions/gettrainsorsb.vue';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			// 标题
			paths: [
				{
					path: '/studyplan/learningmap/addlearningmap',
					name: '添加学习地图'
				}
			],
			input: '',
			textarea: '',
			pickerOptions: {
				disabledDate(v) {
					return v.getTime() < new Date().getTime() - 86400000; //  - 86400000是否包括当天
				}
			},
			timers: '',
			filesobj: {},
			imges: '',
			mapobjs: {
				LM_mapName: '',
				LM_mapContent: '',
				LM_CoverImage: '',
				LM_indateDate: '',
				gtslist: []
			},
			contentstitle: '添加步骤',
			contentdialogTableVisible: false,
			contentobj: {
				SP_planName: '',
				SP_planContent: '',
				spindexs: 0
			},
			buttonname: '立即增加',
			planTableVisible: false,
			planTableobj: {
				PC_planContent: '',
				PC_resourceType: 1,
				PC_planDescribe: '',
				ZY_GUID: ''
			},
			radio: 1,
			changetitle: '请选择策略',
			isstudyactive: 0,
			draweritem: false,
			eexaminobjs: {},
			base64s: ''
		};
	},
	mounted() {
		this.getmapobjs();
	},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		getmapobjs() {
			let obj = {
				LM_GUID: this.$route.query.LM_GUID
			};
			LearnmapDetails(obj).then(res => {
				// console.log(res.data)
				this.mapobjs = res.data.data;
				this.base64s = res.data.data.LM_CoverImage;
			});
		},
		// 添加进度
		newcourser() {
			this.contentdialogTableVisible = true;
			this.buttonname = '立即增加';
			this.contentstitle = '添加步骤';
		},
		// 更改地图类型
		changeradios() {
			this.planTableobj.ZY_GUID = '';
		},
		// 添加学习内容
		addstudycontent(i) {
			let planTableobj = JSON.parse(JSON.stringify(this.planTableobj));
			planTableobj.PC_planContent = '';
			planTableobj.PC_resourceType = 1;
			planTableobj.PC_planDescribe = '';
			planTableobj.ZY_GUID = '';

			this.planTableobj = planTableobj;

			this.isstudyactive = i;
			this.planTableVisible = true;
		},
		delictcourse(i, itm) {
			// 删除内容
			this.$confirm('此操作将永久删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.mapobjs.gtslist[i].gtPlancontents.splice(this.mapobjs.gtslist[i].gtPlancontents.indexOf(itm), 1);
				})
				.catch(() => {});
		},

		// 改变值
		changeexamin(val) {
			// console.log(val)
			this.eexaminobjs = JSON.parse(val);
			this.planTableobj.ZY_GUID = this.eexaminobjs.PCR_GUID;
			this.planTableobj.names = this.eexaminobjs.PCR_RuleTitle;
			this.draweritem = false;
		},
		changecoursea(val) {
			// console.log(val,'改变课程')
			this.eexaminobjs = JSON.parse(val);
			this.planTableobj.ZY_GUID = this.eexaminobjs.CO_GUID;
			this.planTableobj.names = this.eexaminobjs.pro_name;

			this.draweritem = false;
		},
		// 改变实训
		changetrains(val) {
			this.eexaminobjs = JSON.parse(val);
			if (this.eexaminobjs.isactives == 0) {
				this.planTableobj.ZY_GUID = this.eexaminobjs.sx_tr_guid;
				this.planTableobj.names = this.eexaminobjs.tr_name;
			} else {
				this.planTableobj.ZY_GUID = this.eexaminobjs.sx_te_guid;
				this.planTableobj.names = this.eexaminobjs.te_deviceName;
			}

			// console.log(this.eexaminobjs)

			this.draweritem = false;
		},
		addplancontengt() {
			// console.log("添加",this.isstudyactive)
			if (this.planTableobj.PC_planContent == '') {
				this.$message('请输入内容名称');
				return;
			}
			if (this.planTableobj.PC_planDescribe == '') {
				this.$message('请输入内容描述');
				return;
			}
			if (this.planTableobj.ZY_GUID == '') {
				this.$message('请选择学习资源');
				return;
			}
			let mapobjs = JSON.parse(JSON.stringify(this.mapobjs));
			if (!mapobjs.gtslist[this.isstudyactive].gtPlancontents) {
				mapobjs.gtslist[this.isstudyactive].gtPlancontents = [];
			}

			mapobjs.gtslist[this.isstudyactive].gtPlancontents.push(this.planTableobj);
			this.planTableVisible = false;
			this.mapobjs = mapobjs;
			// console.log('添加', this.mapobjs);
		},
		// 选择资源类型
		changezyid() {
			this.draweritem = true;
		},

		// 编辑步骤
		editsd(itm, index) {
			this.buttonname = '立即修改';
			this.contentstitle = '修改步骤';
			let contentobj = JSON.parse(JSON.stringify(this.contentobj));
			contentobj.SP_planName = itm.SP_planName;
			contentobj.SP_planContent = itm.SP_planContent;
			this.contentobj = contentobj;
			this.contentobj.spindexs = index;
			this.contentdialogTableVisible = true;
		},

		// 添加按钮
		editspael() {
			if (this.contentobj.SP_planName == '') {
				this.$message('请输入步骤名');
				return;
			}
			if (this.contentobj.SP_planContent == '') {
				this.$message('请输入步骤内容');
				return;
			}
			let contentobj = JSON.parse(JSON.stringify(this.contentobj));
			if (this.contentstitle == '修改步骤') {
				// this.contentobj.spindexs
				this.mapobjs.gtslist[this.contentobj.spindexs].SP_planName = contentobj.SP_planName;
				this.mapobjs.gtslist[this.contentobj.spindexs].SP_planContent = contentobj.SP_planContent;
			} else {
				this.mapobjs.gtslist.push(contentobj);
			}
			this.contentobj.SP_planName = '';
			this.contentobj.SP_planContent = '';

			this.contentdialogTableVisible = false;
		},
		// 步骤 添加 编辑 删除
		delectsd(ite) {
			this.$confirm('此操作将永久删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.mapobjs.gtslist.splice(this.mapobjs.gtslist.indexOf(ite), 1);
				})
				.catch(() => {});
		},
		// 弹框
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		addmapfles() {
			// console.log(this.$refs.files)
			this.$refs.files.click();
		},
		savesmap() {
			// console.log('保存', this.mapobjs);
			if (this.mapobjs.LM_CoverImage == '') {
				this.$message('请选择封面图片');
				return;
			}
			if (this.mapobjs.LM_indateDate == '') {
				this.$message('请选择有效学习期限');
				return;
			}
			if (this.mapobjs.LM_mapContent == '') {
				this.$message('请输入内容描述');
				return;
			}
			if (this.mapobjs.LM_mapName == '') {
				this.$message('请输入地图名称');
				return;
			}
			if (this.mapobjs.gtslist.length == 0) {
				this.$message('请选择学习计划');
				return;
			}
			this.mapobjs.gtslist.forEach((item, index) => {
				item.SP_sortCode = index;

				item.gtPlancontents.forEach((itm, idx) => {
					itm.PC_sortCode = idx;
				});
			});
			// console.log(this.mapobjs)

			UpdateLearnmap(this.mapobjs).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.$router.push('/studyplan/learningmap/learningmap');
				}
			});
		},
		fileschange(e) {
			this.filesobj = e.target.files;
			// console.log(this.filesobj, '获取文件');
			const file = e.target.files[0];
			const imageType = /image.jpeg|image.png/;
			const fileSizeLimit = 1048576 * 3; // 3MB
			if (!imageType.test(file.type)) {
				this.$message('请上传JPEG、PNG或GIF格式的图片文件。');
				return;
			}

			if (file.size > fileSizeLimit) {
				this.$message('图片文件大小不能超过3MB。');
				return;
			}

			var formData = new FormData();

			formData.append('filedata', file);

			getBase64(file).then(res => {
				// console.log(res,"bese64")
				this.base64s = res;
			});

			changeUploadFileAsync(formData).then(res => {
				// console.log(res.data.data, 'bese64');
				this.mapobjs.LM_CoverImage = res.data.data.url;
				// console.log(this.mapobjs.LM_CoverImage, 'bese64');
			});
		}
	},
	components: {
		titles,
		chiocetrainstra,
		changecourse,
		gettrainsorsb
	}
};
</script>
